export default "__VITE_ASSET__CdU9ozW9__"